// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_loader__31U88","loader_inline":"loader_loader_inline__10JJ4"};